import { searchClient } from "@algolia/client-search";

/* ============================================
   ESTADO COMPARTIDO DE LA BUSQUEDA
============================================ */
export const estado = {
    currentPage: 0,
    isLoadingMore: true,
};

/* ============================================
   🔍 CONFIGURACIÓN DE TIPOS / SECCIONES
============================================ */
export const TYPE_INFO = {
    products: {
        sectionId: 'products-section',
        eventName: 'products-section-change',
    },
    stores: {
        sectionId: 'stores-section',
        eventName: 'stores-section-change',
    },
    markets: {
        sectionId: 'markets-section',
        eventName: 'markets-section-change',
    }
};

/* ============================================
   🔗 CLIENTE DE ALGOLIA
============================================ */
export const client = searchClient(
    process.env.ALGOLIA_APP_ID || '',
    process.env.ALGOLIA_SEARCH_API_KEY || ''
);

// ===============================
//  OBTENER PARÁMETROS DE URL
// ===============================
export function getQueryFromUrl() {
    const params = new URLSearchParams(window.location.search);
    const q = params.get('q');
    const query = params.get('query');
    return {
        query: (query ?? q) || null,
        filters: params.get('filters') || null
    };
}

const GEO_TTL_MS = 5 * 60 * 1000; // 5 minutos

export const getGeoCoords = () => new Promise(resolve => {
    const lat = parseFloat(localStorage.getItem('mt_geo_lat'));
    const lng = parseFloat(localStorage.getItem('mt_geo_lng'));
    const ts  = parseInt(localStorage.getItem('mt_geo_ts'), 10);
    const vigente = !isNaN(ts) && (Date.now() - ts) < GEO_TTL_MS;

    if (!isNaN(lat) && !isNaN(lng) && vigente) return resolve({ lat, lng });

    // Caché caducada o inexistente: la limpiamos y volvemos a pedir la geolocalización.
    localStorage.removeItem('mt_geo_lat');
    localStorage.removeItem('mt_geo_lng');
    localStorage.removeItem('mt_geo_ts');

    if (!navigator.geolocation) return resolve(null);

    navigator.geolocation.getCurrentPosition(
        pos => {
            localStorage.setItem('mt_geo_lat', pos.coords.latitude);
            localStorage.setItem('mt_geo_lng', pos.coords.longitude);
            localStorage.setItem('mt_geo_ts', Date.now());
            resolve({ lat: pos.coords.latitude, lng: pos.coords.longitude });
        },
        () => resolve(null),
        { timeout: 5000, maximumAge: 300000 }
    );
});

export function renderStars(score, totalReviews = 0) {
    
    const scoreContainer = document.createElement('div');
    scoreContainer.className = 'flex items-center mb-2';

    const starsContainer = document.createElement('div');
    starsContainer.className = 'flex';

    const rating = parseFloat(score) || 0;
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 >= 0.5;

    // SVGs base
    const fullStarSVG = `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="gold" width="20" height="20">
            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.286 3.967a1 1 0 00.95.69h4.175c.969 0 1.371 1.24.588 1.81l-3.38 2.455a1 1 0 00-.364 1.118l1.287 3.966c.3.922-.755 1.688-1.54 1.118l-3.38-2.455a1 1 0 00-1.175 0l-3.38 2.455c-.784.57-1.838-.196-1.539-1.118l1.287-3.966a1 1 0 00-.364-1.118L2.05 9.394c-.783-.57-.38-1.81.588-1.81h4.175a1 1 0 00.95-.69l1.286-3.967z" />
        </svg>`;
    
    const emptyStarSVG = `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="lightgray" width="20" height="20">
            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.286 3.967a1 1 0 00.95.69h4.175c.969 0 1.371 1.24.588 1.81l-3.38 2.455a1 1 0 00-.364 1.118l1.287 3.966c.3.922-.755 1.688-1.54 1.118l-3.38-2.455a1 1 0 00-1.175 0l-3.38 2.455c-.784.57-1.838-.196-1.539-1.118l1.287-3.966a1 1 0 00-.364-1.118L2.05 9.394c-.783-.57-.38-1.81.588-1.81h4.175a1 1 0 00.95-.69l1.286-3.967z" />
        </svg>`;
    
    const halfStarSVG = `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" width="20" height="20">
            <defs>
                <linearGradient id="half">
                    <stop offset="50%" stop-color="gold"/>
                    <stop offset="50%" stop-color="lightgray"/>
                </linearGradient>
            </defs>
            <path fill="url(#half)" d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.286 3.967a1 1 0 00.95.69h4.175c.969 0 1.371 1.24.588 1.81l-3.38 2.455a1 1 0 00-.364 1.118l1.287 3.966c.3.922-.755 1.688-1.54 1.118l-3.38-2.455a1 1 0 00-1.175 0l-3.38 2.455c-.784.57-1.838-.196-1.539-1.118l1.287-3.966a1 1 0 00-.364-1.118L2.05 9.394c-.783-.57-.38-1.81.588-1.81h4.175a1 1 0 00.95-.69l1.286-3.967z" />
        </svg>`;

    // Estrellas completas
    for (let i = 0; i < fullStars; i++) {
        starsContainer.insertAdjacentHTML('beforeend', fullStarSVG);
    }

    // Media estrella
    if (hasHalfStar) {
        starsContainer.insertAdjacentHTML('beforeend', halfStarSVG);
    }

    // Vacías restantes
    for (let i = fullStars + (hasHalfStar ? 1 : 0); i < 5; i++) {
        starsContainer.insertAdjacentHTML('beforeend', emptyStarSVG);
    }

    // Texto con puntuación
    const scoreText = document.createElement('span');
    scoreText.className = 'ml-2 text-gray-600';
    scoreText.innerText = `${rating.toFixed(1)}`;

    const starsTotalReviews = document.createElement('span');
    starsTotalReviews.className = 'ml-2 text-gray-600';
    starsTotalReviews.innerText = '('+totalReviews+')';

    scoreContainer.appendChild(scoreText);
    scoreContainer.appendChild(starsContainer);
    scoreContainer.appendChild(starsTotalReviews);

    return scoreContainer;
}
